export default function showProp65Warning(countryCode, regionCode) {
   var country = countryCode && countryCode.toUpperCase();
   var state = regionCode && regionCode.toUpperCase();

   if (country === 'US' && state === 'CA') {
      $('prop-65-warning').removeClass('hidden');
   }
}
